var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeadBar',{attrs:{"isPC":_vm.isPC,"pageData":_vm.pageData},on:{"triggerGetPageData":_vm.getPageData}}),_c('div',{staticStyle:{"width":"100%","height":"70px"}}),_c('router-view',{key:_vm.key,attrs:{"isPC":_vm.isPC,"pageData":_vm.pageData}}),_c('FooterBar',{attrs:{"pageData":_vm.pageData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }